import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from '@opendate-app/setlist';

const UnassignedVenuesWarning = ({ venueOwnerships }) => {
  const unassigned = venueOwnerships.filter((vo) => vo.collects_payouts && !vo.venue_bank_link_id);

  if(unassigned.length === 0){
    return null;
  }

  return (
    <div className="mb-3">
      <Alert
        color="warning"
        size="full-width"
        description={`These venues have no bank account, so their payouts can't be sent: ${unassigned.map((vo) => vo.name).join(", ")}. Assign each one to a bank account below.`}
      />
    </div>
  );
};

UnassignedVenuesWarning.propTypes = {
  venueOwnerships: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    venue_bank_link_id: PropTypes.number,
    collects_payouts: PropTypes.bool
  })).isRequired
};

export default UnassignedVenuesWarning;
